import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import queryParams from "../../utils/getQueryParams"
import { userService } from "../../services/auth"
const getSource = (utmSournce) => {
    switch (utmSournce) {
        case "facebook":
            return "Facebook"
        case "google":
            return "Google"
        case "bing_ads":
        case "bing":
            return "Microsoft"
        case "twitter":
            return "Twitter"
        case "linkedin":
            return "LinkedIN"
        case "mailchimp":
            return "MailChimp"
        case "youtube":
            return "YouTube"
        case "reddit":
            return "Reddit"
        case "quora":
            return "Quora"
        default:
            return "Other"
    }
}
const TrackingConfirmation = () => {
    const navigate = useNavigate()
    const queryData = queryParams()
    useEffect(() => {
        const values = JSON.parse(localStorage.getItem("userValues"))
        console.log("window.dataLayer", values, (window as any).dataLayer);
        (window as any).dataLayer.push({
            event: 'registration_completed',
            query: queryData.qeryString,
            userEmail: values.user_email
        })
        const token = localStorage.getItem("userDetails")
        const utmSource = getSource(queryData.queryobj["utm_source"])

        userService.marketingConnect({
            "traffic_source": utmSource
        }, token).then(data => {
            window.open(data.data.url)
        }).catch(err => {
            console.log("err", err);

        })
        setTimeout(() => {
            navigate("/tracking")
        }, 3000);
    }, [])
    return null
}

export default TrackingConfirmation